/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Username_LabelInputs */

const en_snapshot_history_username_label = /** @type {(inputs: Snapshot_History_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Username`)
};

const fr_snapshot_history_username_label = /** @type {(inputs: Snapshot_History_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom d'utilisateur`)
};

const de_snapshot_history_username_label = /** @type {(inputs: Snapshot_History_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzername`)
};

const it_snapshot_history_username_label = /** @type {(inputs: Snapshot_History_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome utente`)
};

const ru_snapshot_history_username_label = /** @type {(inputs: Snapshot_History_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя пользователя`)
};

const es_snapshot_history_username_label = /** @type {(inputs: Snapshot_History_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de usuario`)
};

const zh_cn2_snapshot_history_username_label = /** @type {(inputs: Snapshot_History_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户名`)
};

const ja_snapshot_history_username_label = /** @type {(inputs: Snapshot_History_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー名`)
};

const hi_snapshot_history_username_label = /** @type {(inputs: Snapshot_History_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता नाम`)
};

const pt_pt2_snapshot_history_username_label = /** @type {(inputs: Snapshot_History_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome de usuário`)
};

/**
* | output |
* | --- |
* | "Username" |
*
* @param {Snapshot_History_Username_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_username_label = /** @type {((inputs?: Snapshot_History_Username_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Username_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_username_label(inputs)
	if (locale === "de") return de_snapshot_history_username_label(inputs)
	if (locale === "it") return it_snapshot_history_username_label(inputs)
	if (locale === "ru") return ru_snapshot_history_username_label(inputs)
	if (locale === "es") return es_snapshot_history_username_label(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_username_label(inputs)
	if (locale === "ja") return ja_snapshot_history_username_label(inputs)
	if (locale === "hi") return hi_snapshot_history_username_label(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_username_label(inputs)
	return en_snapshot_history_username_label(inputs)
});